(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeeroul-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.jr-home');
  const builder = root && root.querySelector('[data-bundle-builder]');
  if (!root || !builder || builder.dataset.ready === 'true') return;

  builder.dataset.ready = 'true';

  const tabs = Array.from(builder.querySelectorAll('[data-bundle-target]'));
  const countEl = builder.querySelector('[data-builder-count]');
  const remainingEl = builder.querySelector('[data-builder-remaining]');
  const progressEl = builder.querySelector('[data-builder-progress]');
  const summaryEl = builder.querySelector('[data-builder-summary]');
  const alertEl = builder.querySelector('[data-builder-alert]');
  const submitBtn = builder.querySelector('[data-builder-submit]');
  const presetBtns = Array.from(builder.querySelectorAll('[data-preset]'));
  const items = Array.from(builder.querySelectorAll('.jr-builder-item')).map((item) => ({
    element: item,
    title: item.dataset.title,
    count: 0,
    output: item.querySelector('output'),
    plus: item.querySelector('[data-qty-action="plus"]'),
    minus: item.querySelector('[data-qty-action="minus"]')
  }));

  let target = 12;
  let price = 'RM168';
  let bundleVariantId = 48838941999321;
  let loading = false;
  let activePreset = '';

  const whatsappUrl = root.dataset.whatsappUrl || '/pages/contact';
  const orderMode = root.dataset.orderMode === 'whatsapp' ? 'whatsapp' : 'checkout';
  const readyLabel = orderMode === 'whatsapp' ? 'Order on WhatsApp' : 'Add to cart';
  const busyLabel = orderMode === 'whatsapp' ? 'Opening...' : 'Adding...';
  // Line-item properties carry the flavour mix so the cart page, the checkout
  // and the order email all show it. Same shape as jeeroul-product.liquid.
  const addToCart = async (variantId, properties) => {
    const response = await fetch(root.dataset.cartAddUrl || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties }] })
    });
    if (!response.ok) {
      let message = 'Could not add to cart. Please try again.';
      try {
        const body = await response.json();
        message = body.description || body.message || message;
      } catch (error) { /* keep the fallback */ }
      throw new Error(message);
    }
    window.location.href = root.dataset.cartUrl || '/cart';
  };
  const totalSelected = () => items.reduce((sum, item) => sum + item.count, 0);
  const mixSummary = () => items.filter((item) => item.count > 0).map((item) => `${item.title} x ${item.count}`).join(', ');
  const buildMessageUrl = (message) => {
    let url;
    try {
      url = new URL(whatsappUrl, window.location.origin);
    } catch (error) {
      url = new URL('/pages/contact', window.location.origin);
    }

    if (url.hostname.includes('wa.me') || url.hostname.includes('whatsapp.com')) {
      url.searchParams.set('text', message);
    } else {
      url = new URL('/pages/contact', window.location.origin);
      url.searchParams.set('mix', message);
    }

    return url.toString();
  };
  const allocatePreset = (titles) => {
    const counts = {};
    for (let i = 0; i < target; i += 1) {
      const title = titles[i % titles.length];
      counts[title] = (counts[title] || 0) + 1;
    }
    return counts;
  };

  const setAlert = (message) => {
    if (alertEl) alertEl.textContent = message || '';
  };

  const update = () => {
    const total = totalSelected();
    const remaining = Math.max(target - total, 0);
    const progress = Math.min((total / target) * 100, 100);

    countEl.textContent = `${total}/${target}`;
    remainingEl.textContent = remaining > 0 ? `Choose ${remaining} more packs` : `${target}-pack mix ready`;
    progressEl.style.width = `${progress}%`;
    summaryEl.textContent = total > 0 ? mixSummary() : 'Start with your favourite flavour, or make it even across all five.';
    submitBtn.disabled = loading || total !== target;
    submitBtn.textContent = loading ? busyLabel : remaining > 0 ? `Select ${remaining} more` : `${readyLabel} · ${price}`;
    presetBtns.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.preset === activePreset);
      button.disabled = loading;
    });

    items.forEach((item) => {
      item.output.value = item.count;
      item.output.textContent = item.count;
      item.minus.disabled = item.count === 0 || loading;
      item.plus.disabled = total >= target || loading;
    });
  };

  const setTarget = (nextTarget, nextPrice, nextVariantId) => {
    target = Number(nextTarget);
    price = nextPrice || price;
    bundleVariantId = Number(nextVariantId || bundleVariantId);
    activePreset = '';
    items.forEach((item) => {
      item.count = 0;
    });
    tabs.forEach((tab) => {
      tab.classList.toggle('is-active', Number(tab.dataset.bundleTarget) === target);
    });
    setAlert('');
    update();
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => setTarget(tab.dataset.bundleTarget, tab.dataset.bundlePrice, tab.dataset.bundleVariant));
  });

  presetBtns.forEach((button) => {
    button.addEventListener('click', () => {
      const presets = {
        balanced: ['Italian Herbs', 'Tuscan Truffle', 'Mexican Fiesta', 'Sichuan Mala', 'Cumin Roast'],
        light: ['Italian Herbs', 'Tuscan Truffle'],
        bold: ['Mexican Fiesta', 'Sichuan Mala', 'Cumin Roast']
      };
      const counts = allocatePreset(presets[button.dataset.preset] || presets.balanced);
      items.forEach((item) => {
        item.count = counts[item.title] || 0;
      });
      activePreset = button.dataset.preset;
      setAlert('Preset loaded. Adjust any flavour before adding.');
      update();
    });
  });

  items.forEach((item) => {
    item.plus.addEventListener('click', () => {
      if (totalSelected() < target) {
        item.count += 1;
        activePreset = '';
        setAlert('');
        update();
      }
    });

    item.minus.addEventListener('click', () => {
      if (item.count > 0) {
        item.count -= 1;
        activePreset = '';
        setAlert('');
        update();
      }
    });
  });

  root.querySelectorAll('[data-pack-shortcut], [data-sticky-target]').forEach((shortcut) => {
    shortcut.addEventListener('click', (event) => {
      const nextTarget = shortcut.dataset.packShortcut || shortcut.dataset.stickyTarget;
      const matchingTab = tabs.find((tab) => tab.dataset.bundleTarget === nextTarget);
      if (matchingTab) {
        event.preventDefault();
        setTarget(matchingTab.dataset.bundleTarget, matchingTab.dataset.bundlePrice, matchingTab.dataset.bundleVariant);
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  submitBtn.addEventListener('click', async () => {
    if (totalSelected() !== target || loading) return;

    const summary = mixSummary();
    loading = true;
    setAlert('');
    update();

    if (orderMode === 'whatsapp') {
      const message = `Hi Jeeroul, I want to order ${target} packs (${price}). Flavour mix: ${summary}.`;
      window.location.href = buildMessageUrl(message);
      return;
    }

    try {
      await addToCart(bundleVariantId, { 'Flavour mix': summary });
    } catch (error) {
      loading = false;
      setAlert(error.message);
      update();
    }
  });

  setTarget(target, price, bundleVariantId);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeeroul-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  // One add-to-cart path for the whole section. Line-item properties carry the
  // flavour mix so the cart page, the checkout and the order email all show it.
  const addToCart = async (root, variantId, quantity, properties) => {
    const response = await fetch(root.dataset.cartAddUrl || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1, properties: properties || {} }] })
    });
    if (!response.ok) {
      let message = 'Could not add to cart. Please try again.';
      try {
        const body = await response.json();
        message = body.description || body.message || message;
      } catch (error) { /* keep the fallback */ }
      throw new Error(message);
    }
    window.location.href = root.dataset.cartUrl || '/cart';
  };

  document.querySelectorAll('[data-product-single]').forEach((form) => {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    const root = form.closest('.jr-product');
    const input = form.querySelector('[data-product-single-input]');
    const alertEl = root ? root.querySelector('[data-product-single-alert]') : null;
    const submitBtn = form.querySelector('[data-product-single-submit]');
    form.querySelectorAll('[data-product-single-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = (parseInt(input.value, 10) || 1) + (button.dataset.productSingleQty === 'plus' ? 1 : -1);
        input.value = Math.max(1, next);
      });
    });
    form.addEventListener('submit', async (event) => {
      if (!submitBtn) return;
      event.preventDefault();
      const variantId = new FormData(form).get('id');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
      if (alertEl) alertEl.textContent = '';
      try {
        await addToCart(root, variantId, input.value, {});
      } catch (error) {
        if (alertEl) alertEl.textContent = error.message;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to cart';
      }
    });
  });

  const builders = document.querySelectorAll('[data-product-builder]');
  builders.forEach((builder) => {
    if (builder.dataset.ready === 'true') return;
    builder.dataset.ready = 'true';

    const tabs = Array.from(builder.querySelectorAll('[data-product-target]'));
    const countEl = builder.querySelector('[data-product-count]');
    const remainingEl = builder.querySelector('[data-product-remaining]');
    const progressEl = builder.querySelector('[data-product-progress]');
    const summaryEl = builder.querySelector('[data-product-summary]');
    const alertEl = builder.querySelector('[data-product-alert]');
    const submitBtn = builder.querySelector('[data-product-submit]');
    const presetBtns = Array.from(builder.querySelectorAll('[data-product-preset]'));
    const items = Array.from(builder.querySelectorAll('[data-product-title]')).map((item) => ({
      element: item,
      title: item.dataset.productTitle,
      count: 0,
      output: item.querySelector('output'),
      plus: item.querySelector('[data-product-qty="plus"]'),
      minus: item.querySelector('[data-product-qty="minus"]')
    }));

    let activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    let target = parseInt(activeTab ? activeTab.dataset.productTarget : '12', 10) || 12;
    let variantId = Number(activeTab ? activeTab.dataset.productVariant : 0);
    let loading = false;
    let activePreset = '';
    const productRoot = builder.closest('.jr-product');
    const whatsappUrl = productRoot ? productRoot.dataset.whatsappUrl : '/pages/contact';
    const orderMode = productRoot && productRoot.dataset.orderMode === 'whatsapp' ? 'whatsapp' : 'checkout';
    const readyLabel = orderMode === 'whatsapp' ? 'Order on WhatsApp' : 'Add to cart';
    const busyLabel = orderMode === 'whatsapp' ? 'Opening...' : 'Adding...';
    const totalSelected = () => items.reduce((sum, item) => sum + item.count, 0);
    const mixSummary = () => items.filter((item) => item.count > 0).map((item) => `${item.title} x ${item.count}`).join(', ');
    const activePrice = () => {
      const priceText = activeTab ? activeTab.querySelector('span')?.textContent?.trim() : '';
      return priceText || '';
    };
    const buildMessageUrl = (message) => {
      let url;
      try {
        url = new URL(whatsappUrl, window.location.origin);
      } catch (error) {
        url = new URL('/pages/contact', window.location.origin);
      }

      if (url.hostname.includes('wa.me') || url.hostname.includes('whatsapp.com')) {
        url.searchParams.set('text', message);
      } else {
        url = new URL('/pages/contact', window.location.origin);
        url.searchParams.set('mix', message);
      }

      return url.toString();
    };
    const setAlert = (message) => {
      if (alertEl) alertEl.textContent = message || '';
    };
    const allocatePreset = (titles) => {
      const counts = {};
      for (let i = 0; i < target; i += 1) {
        const title = titles[i % titles.length];
        counts[title] = (counts[title] || 0) + 1;
      }
      return counts;
    };

    const update = () => {
      const total = totalSelected();
      const remaining = Math.max(target - total, 0);
      countEl.textContent = `${total}/${target}`;
      remainingEl.textContent = remaining > 0 ? `Choose ${remaining} more packs` : `${target}-pack mix ready`;
      progressEl.style.width = `${Math.min((total / target) * 100, 100)}%`;
      summaryEl.textContent = total > 0 ? mixSummary() : 'Start with a preset or tap plus on your favourites.';
      submitBtn.disabled = loading || total !== target || !variantId;
      submitBtn.textContent = loading ? busyLabel : remaining > 0 ? `Select ${remaining} more` : activePrice() ? `${readyLabel} · ${activePrice()}` : readyLabel;
      presetBtns.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.productPreset === activePreset);
        button.disabled = loading;
      });
      items.forEach((item) => {
        item.output.value = item.count;
        item.output.textContent = item.count;
        item.minus.disabled = item.count === 0 || loading;
        item.plus.disabled = total >= target || loading;
      });
    };

    const setTarget = (tab) => {
      activeTab = tab;
      target = parseInt(tab.dataset.productTarget, 10) || target;
      variantId = Number(tab.dataset.productVariant || variantId);
      activePreset = '';
      items.forEach((item) => {
        item.count = 0;
      });
      tabs.forEach((button) => button.classList.toggle('is-active', button === tab));
      setAlert('');
      update();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setTarget(tab));
    });

    presetBtns.forEach((button) => {
      button.addEventListener('click', () => {
        const presets = {
          balanced: ['Italian Herbs', 'Tuscan Truffle', 'Mexican Fiesta', 'Sichuan Mala', 'Cumin Roast'],
          light: ['Italian Herbs', 'Tuscan Truffle'],
          bold: ['Mexican Fiesta', 'Sichuan Mala', 'Cumin Roast']
        };
        const counts = allocatePreset(presets[button.dataset.productPreset] || presets.balanced);
        items.forEach((item) => {
          item.count = counts[item.title] || 0;
        });
        activePreset = button.dataset.productPreset;
        setAlert('Preset loaded. Adjust any flavour before adding.');
        update();
      });
    });

    items.forEach((item) => {
      item.plus.addEventListener('click', () => {
        if (totalSelected() < target) {
          item.count += 1;
          activePreset = '';
          setAlert('');
          update();
        }
      });
      item.minus.addEventListener('click', () => {
        if (item.count > 0) {
          item.count -= 1;
          activePreset = '';
          setAlert('');
          update();
        }
      });
    });

    submitBtn.addEventListener('click', async () => {
      if (totalSelected() !== target || loading || !variantId) return;

      const summary = mixSummary();
      loading = true;
      setAlert('');
      update();

      if (orderMode === 'whatsapp') {
        const message = `Hi Jeeroul, I want to order ${target} packs ${activePrice()}. Flavour mix: ${summary}.`;
        window.location.href = buildMessageUrl(message);
        return;
      }

      try {
        await addToCart(productRoot, variantId, 1, { 'Flavour mix': summary });
      } catch (error) {
        loading = false;
        setAlert(error.message);
        update();
      }
    });

    if (activeTab) setTarget(activeTab);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
